import uiucLogo from "@/assets/contents/uiuc-logo.jpeg";
import nthuLogo from "@/assets/contents/nthu-logo.png";
import tkuLogo from "@/assets/contents/tku-logo.png";

export default [
    {
        title: "University of Illinois Urbana-Champaign",
        role: "Master of Computer Science",
        startDate: "2021",
        endDate: "2021",
        image: uiucLogo,
        linkURL: "",
        descriptions: [
            "Deffered to 2021 Fall",
        ],
    },
    {
        title: "National Tsing Hua University",
        role: "BSc in Computer Science",
        startDate: "2015",
        endDate: "2018",
        image: nthuLogo,
        linkURL: "",
        descriptions: [
            "Overall GPA: 3.99/4.3",
            "Class rank: 3/45",
        ],
    },
    {
        title: "TamKang University",
        role: "Completed Freshman Year Coursework in Computer Science",
        startDate: "2014",
        endDate: "2015",
        image: tkuLogo,
        linkURL: "",
        descriptions: [
            "GPA: 92.76/100",
            "Class rank: 1/59",
        ],
    },
];
